import * as serializer from 'jsonrpc-serializer';
import hash from 'object-hash';

import {
  CHANNEL_REQUEST,
  CHANNEL_NOTIFICATION,
  CHANNEL_SUCCESS,
  CHANNEL_ERROR,
} from './Dispatcher';

const METHOD_NAME = 'pub-sub-transport';
const TRANSPORT_MARK = 'published-by-transport';

const publishToTransport = (transport, data) => {
  if (data && data.meta && data.meta[TRANSPORT_MARK]) {
    // don't publish events came from transport
    return;
  }
  transport.publish(METHOD_NAME, data);
};

const publishToDispatcher = (dispatcher, type, payload) => {
  const getChannelName = channel => (
    channel === 'notification' ? CHANNEL_NOTIFICATION : channel
  );

  dispatcher.publish(getChannelName(type), payload.method,
    { data: payload, meta: { [TRANSPORT_MARK]: true } },
  );
};

const subscribers = {};

export const connect = (transport, dispatcher) => {
  subscribers[hash.MD5(transport)] = {
    dispatcher: [
      dispatcher.subscribe(CHANNEL_REQUEST, data => publishToTransport(transport, data)),
      dispatcher.subscribe(CHANNEL_NOTIFICATION, data => publishToTransport(transport, data)),
      dispatcher.subscribe(CHANNEL_SUCCESS, data => publishToTransport(transport, data)),
      dispatcher.subscribe(CHANNEL_ERROR, data => publishToTransport(transport, data)),
    ],
    transport: transport.subscribe(METHOD_NAME, (data) => {
      const { type } = serializer.deserializeObject(data);
      publishToDispatcher(dispatcher, type, data);
    }),
  };
};

export const disconnect = (transport, dispatcher) => {
  const subscribersInfo = subscribers[hash.MD5(transport)];

  if (!subscribersInfo) {
    return;
  }

  subscribersInfo.dispatcher.map(subscriberId => dispatcher.unsubscribe(subscriberId));
  transport.unsubscribe(subscribersInfo.transport);
};

export default { connect, disconnect };



// WEBPACK FOOTER //
// ./src/WebBridge/connector.js